<template>
  <div class="flexChart">
    <div class="chartContent">
      <div class="content">
        Emissionen der Stromerzeugung der letzten 30 Tage <span class="color">2024</span> und
        <span class="color2">2025</span> in Tonnen
      </div>
    </div>
    <div class="chartContainer" ref="chartContainer">
      <div ref="chart" class="lineChart"></div>
    </div>
  </div>
</template>

<script>
import { store } from "../store";
import * as d3 from "d3";
import { timeParse } from "d3";

import _ from "lodash";

export default {
  data() {
    return {
      store,
    };
  },
  props: {
    dataEmissTons: {
      type: Array,
      required: true,
    },
  },
  methods: {
    handleResize: _.debounce(function () {
      this.windowWidth = window.innerWidth;
      const chartParent = this.$refs.chart;
      const svgNode = chartParent.querySelector("svg");
      chartParent.removeChild(svgNode);
      this.drawChart(this.$refs.chartContainer.clientWidth);
    }, 200),
    drawChart(containerWidth) {
      const chartWidth = containerWidth;
      //console.log("drawChart dataTempTons", console.log(JSON.stringify(this.dataTempTons)));

      const dataHistory = this.dataEmissTons[1];
      const dataNow = this.dataEmissTons[0];

      function formatNumber(number) {
        var formattedNumber = (parseInt(number) / 1000).toLocaleString("en-US", { minimumFractionDigits: 3 });
        formattedNumber = formattedNumber.replace(",", ".");
        return formattedNumber;
      }

      // Convert date strings to Date objects and add formatted date field
      dataNow.forEach(function (item) {
        var dateString = item[0];
        var dateParts = dateString.split(".");
        var dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
        var dateObjectChart = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
        item.push(dateObject);
        item.push(dateObjectChart);
      });
      dataHistory.forEach(function (item) {
        var dateString = item[0];
        var dateParts = dateString.split(".");
        var dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);

        var dateObjectChart = new Date(parseInt(dateParts[2]) + 1, dateParts[1] - 1, dateParts[0]);
        item.push(dateObject);
        item.push(dateObjectChart);
      });

      const data = dataNow.map((d) => ({
        date: d[0],
        value: d[1],
        datetime: d[2],
        datechart: d[3],
      }));

      const data2 = dataHistory.map((d) => ({
        date: d[0],
        value: d[1],
        datetime: d[2],
        datechart: d[3],
      }));

      data.sort((a, b) => new Date(a.datetime) - new Date(b.datetime));
      data2.sort((a, b) => new Date(a.datetime) - new Date(b.datetime));

      const margin = { top: 10, right: 5, bottom: 17, left: 32 };
      const width = chartWidth - margin.left - margin.right;
      const height = 96 - margin.top - margin.bottom;

      // Set the width of the left axis
      const yAxisWidth = 16;
      const xAxisHeight = 16;
      const yAxisTooltipMargin = 2;

      const svg = d3
        .select(this.$refs.chart)
        .append("svg")
        .attr("width", width + margin.left + margin.right)
        .attr("height", height + margin.top + margin.bottom)
        .append("g")
        .attr("transform", `translate(${margin.left}, ${margin.top})`);

      // axis
      const x = d3
        .scaleTime()
        .domain([d3.min(data, (d) => d.datechart), d3.max(data2, (d) => d.datechart)])
        .range([0, width - yAxisWidth]);
      const xAxis = d3.axisBottom(x);
      xAxis.tickSize(0).tickSizeInner(0);

      const y = d3.scaleLinear().domain([100000, 850000]).range([height, 0]).nice();

      const yAxis = d3
        .axisLeft(y)
        .ticks(4)
        .tickValues([100000, 300000, 500000, 700000, 900000])
        .tickSize(0)
        .tickSizeInner(-width)
        //.tickFormat((d) => d); // add " Grad" to tick value 5#
        .tickFormat((d) => d.toLocaleString("de-DE"));

      // .tickFormat((d) => {
      //   // Custom formatting logic
      //   const formattedValue = d3.format("..0f")(d);
      //   // Additional formatting or modifications
      //   const modifiedValue = formattedValue; // Apply your custom formatting or modifications to `formattedValue`
      //   return modifiedValue;
      // });

      svg
        .append("g")
        .call(yAxis)
        .classed("axis-label", true)
        .attr("transform", "translate(" + yAxisWidth + ", 0)");

      svg
        .append("g")
        .attr("transform", `translate(${margin.left + 5}, ${height + 2})`)
        .attr("width", `translate(100% - ${yAxisWidth})`)
        .call(xAxis)
        .classed("axis-label", true)
        .attr("opacity", 0);

      svg
        .append("g")
        .attr("transform", `translate(${margin.left}, ${height + 2})`)
        .attr("width", `${width})`)
        .classed("axis-label", true);

      const firstDayMonth = data[0].date.slice(0, 6);
      const lastDayMonth = data[data.length - 1].date.slice(0, 6);
      svg
        .append("text")
        .attr("class", "axis-label")
        .attr("x", 15)
        .attr("y", height + margin.bottom - 5)
        .attr("text-anchor", "start")
        .attr("fill", "var(--mm-grey-400)")
        .text(firstDayMonth);

      svg
        .append("text")
        .attr("class", "axis-label")
        .attr("x", width)
        .attr("y", height + margin.bottom - 5)
        .attr("text-anchor", "end")
        .attr("fill", "var(--mm-grey-400)")
        .text(lastDayMonth);

      // first linie
      const line = d3
        .line()
        .x((d) => x(d.datechart))
        .y((d) => y(d.value));

      svg
        .append("path")
        .datum(data)
        .attr("fill", "none")
        .attr("stroke", "var(--mm-orange-color2)")
        .attr("stroke-width", 2)
        .attr("d", line)
        .attr("transform", "translate(" + (yAxisWidth + yAxisTooltipMargin) + ", 0)");

      //second linie
      const line2 = svg
        .append("path")
        .datum(data2)
        .attr("fill", "none")
        .attr("stroke", "var(--mm-orange-color)")
        .attr("d", line)

        .attr("transform", "translate(" + (yAxisWidth + yAxisTooltipMargin) + ", 0)")
        .attr("stroke-width", 2);

      // Add tooltip to chart
      const tooltip = d3.select(this.$refs.chart).append("div").attr("class", "tooltip").style("opacity", 0);

      // Add vertical line on mouseover
      const verticalLine = svg
        .append("line")
        .attr("class", "vertical-line")
        .attr("y1", 0)
        .attr("y2", height)
        .attr("stroke", "var(--mm-grey-700)")
        .attr("stroke-width", 1)
        .attr("opacity", 0);

      // Add horizontal line on mouseover
      const horizontalLine = svg
        .append("line")
        .attr("class", "horizontal-line")
        .attr("x1", 0)
        .attr("x2", width)
        .attr("stroke", "grey")
        .attr("stroke-width", 1)
        .attr("opacity", 0);

      var circleLine2 = svg
        .append("circle")
        .attr("class", "circle")
        .attr("r", 3)
        .attr("fill", "var(--mm-orange-color)")
        .attr("stroke", "var(--mm-grey-700)")
        .attr("stroke-width", 1.5)
        .attr("opacity", 0);
      var circleLine1 = svg
        .append("circle")
        .attr("class", "circle")
        .attr("r", 3)
        .attr("fill", "var(--mm-orange-color2)")
        .attr("stroke", "var(--mm-grey-700)")
        .attr("stroke-width", 1.5)
        .attr("opacity", 0);

      const mask = svg
        .append("rect")
        .attr("width", width + margin.left + 0)
        .attr("height", height + margin.top + margin.bottom)
        .attr("transform", "translate(" + (yAxisWidth + yAxisTooltipMargin) + ", 0)")
        .style("fill", "transparent")
        .style("cursor", "pointer")
        .attr("class", "mask")
        .on("mouseover", () => {})
        .on("mouseout", () => {
          tooltip.style("opacity", 0);
          verticalLine.attr("opacity", 0);
          circleLine1.attr("opacity", 0);
          circleLine2.attr("opacity", 0);
        })
        .on("touchmove mousemove", mouseMove);

      // Add mouseover event handler to chart
      function mouseMove(event) {
        // Get mouse coordinates and invert them to get chart coordinates
        const [xCoord, yCoord] = d3.pointer(event);
        const x0 = x.invert(xCoord);
        const y0 = y.invert(yCoord);

        // Get nearest data point to mouse coordinates
        const containerOffset = svg.node().getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        const bisectLine1 = d3.bisector((d) => d.datechart).left;
        const iLine1 = bisectLine1(data, x0, 1);
        const dLine1_0 = data[iLine1 - 1];
        const dLine1_1 = data[iLine1];
        const d = x0 - dLine1_0.datechart >= dLine1_1.datechart - x0 ? dLine1_1 : dLine1_0;

        const bisectLine2 = d3.bisector((d2) => d2.datechart).left;
        const iLine2 = bisectLine2(data2, x0, 1);
        const dLine2_0 = data2[iLine2 - 1];
        const dLine2_1 = data2[iLine2];
        const d2 = x0 - dLine1_0.datechart >= dLine2_1.datechart - x0 ? dLine2_1 : dLine2_0;

        const dateString = d.date;
        const [day, month] = dateString.split(".");
        // Update tooltip and lines
        tooltip
          .style("opacity", 1)
          .html(
            `<div class="tooltipFlex"><span>${day}.${month}.</span><span class="d1 color2 ${
              d2 != undefined && d.value >= d2.value ? " order" : ""
            }"><b>${d.value != null ? formatNumber(d.value) + "&nbsp;t" : ""}</b></span>
            ${
              typeof d2 !== "undefined"
                ? '<span class="d2 color"><b>' + formatNumber(d2.value) + "&nbsp;t" + "</b><span>"
                : ""
            }</div>`
          )
          .style("left", event.pageX - containerOffset.left + "px")
          .style("top", height / 2 + "px")
          .style("cursor", "pointer");

        verticalLine
          .attr("x1", x(d.datechart) + (yAxisWidth + yAxisTooltipMargin) - 1)
          .attr("x2", x(d.datechart) + (yAxisWidth + yAxisTooltipMargin) - 1)
          .attr("class", "verticalLine")
          .attr("opacity", 1);

        circleLine1
          .attr("cx", x(d2.datechart) + (yAxisWidth + yAxisTooltipMargin) - 1)
          .attr("cy", y(d.value))
          .attr("opacity", 1);

        circleLine2
          .attr("cx", x(d2.datechart) + (yAxisWidth + yAxisTooltipMargin) - 1)
          .attr("cy", y(d2.value))
          .attr("opacity", 1);

        // horizontalLine.attr("y1", y(d.value)).attr("y2", y(d.value)).attr("class", "horizontalLine").attr("opacity", 1);
        // circle.attr("cx", x(d.date)).attr("cy", y(d.value)).attr("opacity", 1);
      }
    },
  },
  watch: {
    dataEmissTons() {
      let chartWidth = this.$refs.chartContainer.clientWidth;
      this.drawChart(chartWidth);
    },
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.lineChart svg {
  width: 100%;
  height: auto;
}
</style>
